import { useMemo } from 'react';
import ElementOptions from './element-options';

type Props = {
    data: any;
    onChange: (data: { name: string; value: string }) => void;
    value?: any;
    error?: string;
};

const ItemOptions = ({ data, onChange, value, error }: Props) => {
    const Component = useMemo(() => {
        switch (data.type) {
            case 'select':
                return ElementOptions.Select;
            case 'number':
                return ElementOptions.Text;
            case 'radio':
                return ElementOptions.Radio;
            case 'image':
                return ElementOptions.UploadImage;
            default:
                return ElementOptions.Text;
        }
    }, []);

    const handleOnChange = (value: any) => {
        onChange && onChange({ name: data.name, value: value });
    }; return (
        <div className="my-2">
            <Component {...data} onChange={handleOnChange} value={value} error={error} />
        </div>
    );
};

export default ItemOptions;
